<template>
	<div class="UserSimpleList">
		<h2 v-if="title">{{ $t(title) }}</h2>
		<table class="st-table st-table--full">
            <thead>
                <tr>
                	<th class="UserSimpleList__th--image"></th>

                    <!-- name -->
                    <th class="UserSimpleList__th--name">{{ $t("Name") }}</th>
                    <!-- /name -->

					<!-- role -->
					<th class="UserSimpleList__th--role">{{ $t("Role") }}</th>
					<!-- /role -->
                </tr>
            </thead>
            <tbody>
                <tr v-if="users && users.length > 0" v-for="(user, index) in users" :class="{ 'has-action' : hasAction(user) }">
					<td>
						<img v-if="user.image" :src="user.image.url" :alt="(user.fancyname ? user.fancyname : user.title)" width="50">
					</td>
                    <!-- name -->
                    <td>
                    	<c-user
                    	:simple="simpleusers"
						:data="user"
						:canedit="(user.urls && Object.keys(user.urls).length > 0)"
						></c-user>
                	</td>
                    <!-- /name -->

                    <!-- role -->
					<td>
						<div v-if="user.mainrole">
							{{ $t(user.mainrole.singular) }}
						</div>
						<div v-else-if="user.leader">
							<c-user
							:simple="simpleusers"
							:data="user.leader"
							:canedit="(user.leader && user.leader.urls && Object.keys(user.leader.urls).length > 0)"
							></c-user>
						</div>
						<div v-else>
							---
						</div>
					</td>
					<!-- /role -->
                </tr>
                <tr v-if="!users || users.length <= 0">
					<td colspan="3">
						<div v-if="loading" class="text-center"><div class="spinner"></div></div>
						<div v-else>{{ $t('Nothing Found') }}</div>
					</td>
            	</tr>
            </tbody>
        </table>
		<router-link v-if="newlink" :to="newlink" class="st-btn st-btn--small st-btn--submit">New</router-link>
	</div>
</template>

<script>
import CUser from '@/components/c-user';

export default {
	name: 'UserSimpleList',
	components: {
		CUser
	},
	computed: {
		loading(){
			return this.$store.getters.loading;
		}
	},
	methods: {
		hasAction(user){
			if(!user) return false;
			if(!user.urls) return false;
			return Object.keys(user.urls).length > 0;
		}
	},
	props: ['users', 'title', 'simpleusers' , 'newlink'],

}
</script>

<style scoped>
.UserSimpleList__th--image {
	width: 100px;
}
.UserSimpleList__th--role {
	width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/UserSimpleList.vue